import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import LoginModal from '../../components/navigation/LoginModal';
import HeroSection from './components/HeroSection';
import ForgotPasswordModal from '../../components/navigation/ForgotPasswordModal';

const LoginPWA = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isForgotOpen, setIsForgotOpen] = useState(false);
  const [modalMode, setModalMode] = useState('login');

  const handleOpenModal = (mode) => {
    setModalMode(mode);
    setIsModalOpen(true);
    setIsForgotOpen(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOpenForgot = () => {
    setIsModalOpen(false);
    setIsForgotOpen(true);
  };

  const handleAuthSuccess = (data) => {
    setIsAuthenticated(true);
    const korisnikRuolo = data.ruolo; 

    setTimeout(() => {
      switch (korisnikRuolo) {
        case 'superAdmin':
        case 'Admin':
          navigate('/admin-menu-page');
          break;
        case 'Owner':
          navigate('/home-dashboard-owner');
          break;
        case 'cco-admin':case 'gru-admin':
        case 'cco-utente':
          navigate('/acv-home'); 
          break;
        case 'User':
          navigate('/home-dashboard-dipendente'); 
          break;
        case 'qrScanner':
          navigate('/qr-code-reader'); 
          break;
        default:
          navigate('/home-dashboard-dipendente');
          break;
      }
    }, 300);
  };

  return (
    <>
      <Helmet>
        <title>{t('landing.seo_title')}</title>
        <meta name="description" content={t('landing.seo_description')} />
      </Helmet>

      <div className="relative min-h-screen bg-background flex flex-col">
        {/* Main dio */}
        <main role="main" className="flex-grow w-full">
          <HeroSection 
            onLoginClick={() => handleOpenModal('login')}
            onRegisterClick={() => handleOpenModal('register')}
          />
        </main>

        {/* Minimalistički Footer - Tekstualni link skroz dole */}
        <footer className="w-full py-10 text-center">
          <div className="max-w-6xl mx-auto px-4">
            <p className="text-xs font-medium text-muted-foreground/60 tracking-widest">
              © {new Date().getFullYear()}{' '}
              <a 
                href="https://desk.orizon-aix.com" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-primary transition-colors underline-offset-4 hover:underline"
              >
                ORIZONDESK
              </a>
            </p>
          </div>
        </footer>

        {/* MODALI */}
        <LoginModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSuccess={handleAuthSuccess}
          onForgotPassword={handleOpenForgot}
        />

        <ForgotPasswordModal 
          isOpen={isForgotOpen} 
          onClose={() => setIsForgotOpen(false)} 
          onBackToLogin={() => {
            setIsForgotOpen(false);
            setIsModalOpen(true);
          }}
        />
      </div>
    </>
  );
};

export default LoginPWA;